import React from "react";
import styled from "@emotion/styled";
import { theme } from "@src/components/nessie-web";
import { AnimatedDiv, Transition } from "@src/components/AnimatedDiv";
import { layout } from "styled-system";

export const InputInfo = styled("div")<{ display?: "inline-block" }>`
  text-align: left;
  font-size: 15px;
  color: ${theme.colors.contentSecondary};
  padding-bottom: 6px;
  padding-left: 6px;
  padding-top: calc(1rem - 15px);

  ${layout}
`;

export const InputError = styled(InputInfo)`
  color: ${theme.colors.contentDanger};
`;
